import urlJoin from 'url-join';
const getMethodPath = (descriptor, methodName) => urlJoin(descriptor.serviceMetadata.rest?.basePath || '/', descriptor.restMethodsMetadata[methodName].path || '/');
export { getMethodPath };
//# sourceMappingURL=rest.js.map